import * as actions from "./../actions/actionTypes";
const initState = false;
const requestReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.REQUEST:
      return action.payload;
    default:
      return state;
  }
};

export default requestReducer;
